import type { BaseClient } from "./client";
import type { APIResponse } from "./types";

const BASE = "/api/v1/operator";

export interface FeatureGate {
  name: string;
  description: string;
  default: boolean;
  enabled: boolean;
}

export interface FeatureGatesResponse {
  gates: FeatureGate[];
}

/**
 * Features API: reads the platform-wide feature-gate registry resolved
 * against the active OpenDeskCluster CR.
 */
export class FeaturesApi {
  constructor(private readonly client: BaseClient) {}

  /** Fetch all feature gates with their current and default state. */
  async getFeatureGates(): Promise<APIResponse<FeatureGatesResponse>> {
    return this.client.get<FeatureGatesResponse>(`${BASE}/features`);
  }
}
